import React, { Component } from 'react';
import logo from '../images/logo.svg';
import googleLogo from '../images/sign-in-with-google.png';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { BeatLoader } from 'react-spinners';
import { firebase } from '../firebase';
import { auth } from '../firebase';

require('./index.css');

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: null,
      loading: true,
      signOut: false,
      user: '',
      isChecked: false
    }
  }

  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value
    });
  }

  handlePasswordChange = (event) => {
    this.setState({
      password: event.target.value
    });
  }

  handleCheckChange = (event) => {
    this.setState({
      isChecked: !this.state.isChecked
    });
  }

  handleGoogleLogin = (event) => {
    event.preventDefault();

    if (!this.state.isChecked) {
      this.setState({
        error: { 
          message:'Please agree to our Terms, Conditions, and Privacy Policy before logging in'
        }
      });
    } else {
      auth.doSignInWithGoogle(firebase.provider)      
      .then(() => {
        this.setState({ 
          email: '',
          password: '',
          error: null 
        });
        this.props.push('/home');        
      })
      .catch(error => {
        this.setState({
          error: error.message
        });
      });
    }

    // auth.doSignInWithGoogle(firebase.provider)
    // .then((result) => {
    //   //const token = result.credential.accessToken;
    //   const userEmail = result.user.email.replace(/[.#$@]/g, "");
    //   this.setState({
    //     user: userEmail
    //   })
    //   firebase.database.ref('users/' + userEmail).on('value', (status) => {
    //     this.setState({
    //       signOut: status.val()
    //     })
    //   }); 
    // })
    // .then(() => {
    //   if (this.state.signOut === true) {
    //     this.setState({
    //       error: {message: 'You are logged in to another device. Please sign out from all other devices and try again.'},
    //     });
    //     auth.doSignOut();
    //   } else {
    //     firebase.database.ref('users/' + this.state.user).set(true);
    //     this.props.push('/home');
    //   }
    // })
    // .catch((error) => {
    //   const errorMessage = error.message;
    //   //const email = error.email;
    //   //const credential = error.credential;
    //   console.log(errorMessage);
    // });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const {
      email,
      password,
    } = this.state;

    auth.doSignInWithEmailAndPassword(email, password)      
    .then(() => {
      this.setState({ 
        email: '',
        password: '',
        error: null 
      });
      this.props.push('/home');        
    })
    .catch(error => {
      this.setState({
        error: error
      });
    });

    // const user = email.replace(/[.#$@]/g, "");
  
    // firebase.database.ref('users/' + user).on('value', (status) => {
    //    if (status.val() === true) {
    //     this.setState({
    //       error: {message: 'You are logged in to another device. Please sign out from all other devices and try again.'}
    //     });
    //    } else {
    //       auth.doSignInWithEmailAndPassword(email, password)      
    //       .then(() => {
    //         this.setState({ 
    //           email: '',
    //           password: '',
    //           error: null 
    //         });
    //         firebase.database.ref('users/' + user).set(true);
    //         this.props.push('/home');        
    //       })
    //       .catch(error => {
    //         this.setState({
    //           error: error
    //         });
    //       });
    //     }
    //   });
    }

  componentDidMount() {
    setTimeout(() => {
        this.setState({
            loading: false
        });
    }, 700);
  }

  render() {
    const {
      email,
      password,
      error,
      loading,
    } = this.state;

    const isInvalid = 
      password === '' ||
      email === '';

    return (
      <div>
        <div className='loading'>
          <BeatLoader
            color={'#446E9B'} 
            loading={loading}/>
        </div>
        {!loading &&
          <div className='card text-white bg-primary mb-3'>
              <div className='card-header'>
                <div>
                  <img src={logo} className='login-logo' alt='nerve-logo' />
                    NeuroSchematic &nbsp;
                  <i className='fa fa-registered'></i>
                </div>
                <div>Log In</div>
              </div>
              <div className='card-body'>
                  <form onSubmit={ this.handleSubmit }>

                    <div className='form-group'>
                      <label htmlFor='email'>Email</label>
                      <input 
                        type='email' 
                        className='form-control' 
                        id='email' 
                        placeholder='Enter Email' 
                        value={ email }
                        onChange={ this.handleEmailChange } />
                    </div>

                    <div className='form-group'>
                      <label htmlFor='passWord'>Password</label>
                      <input 
                        type='password' 
                        className='form-control' 
                        id='passWord' 
                        placeholder='Enter Password' 
                        value={ password }
                        onChange={ this.handlePasswordChange } />
                    </div>
                    
                    <h6>Don't have an account? &nbsp; <a href='/signup'>SIGN UP</a></h6>
                    <h6>Forgot password? &nbsp; <a href='/reset-user'>RESET PASSWORD</a></h6>
                    <div style={{ marginTop: 20 }}>
                      <input
                        name='isChecked'
                        type='checkbox'
                        checked={this.state.isChecked}
                        onChange={this.handleCheckChange} 
                        style={{ float: 'left', marginTop: 6, transform: 'scale(1.3)' }}/>
                      <p style={{ marginLeft: 25 }}>I agree to the <a href='http://www.neuroschematic.com/terms-conditions/' target='_blank' rel='noopener noreferrer'>Terms, Conditions,</a> and <a href='http://www.neuroschematic.com/privacy-policy/' target='_blank' rel='noopener noreferrer'>Privacy Policy.</a></p>
                    </div>
                    <div className='buttons'>
                      <img src={googleLogo} className='google-logo' onClick={ this.handleGoogleLogin } alt='google-login-logo' />
                      <button disabled={isInvalid} type='submit' className='btn btn-secondary loginButton'>
                        Log In
                      </button>
                    </div>
                    { error && <p style={{ color: '#f46b42'}}>{error.message}</p> }
                  </form>
              </div>
              <h5 style={{ textAlign: 'center', marginBottom: 30 }}>Neuroschematic is best viewed on desktop or laptop screens</h5>
          </div>
        }
      </div>
    );
  }
}

//-----Redux Functions-----
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ push }, dispatch); 
};

export default connect(null, mapDispatchToProps)(LoginForm);


// WEBPACK FOOTER //
// ./src/login/index.js